import { render } from "./ProductDetail.vue?vue&type=template&id=6540bb18&scoped=true&ts=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=6540bb18&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6540bb18"]])

export default __exports__